/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./order-list-tips.vue?vue&type=template&id=ff86a518&"
import script from "./order-list-tips.vue?vue&type=script&lang=ts&"
export * from "./order-list-tips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports